// extracted by mini-css-extract-plugin
export default {"projectsList":"NavigationPanel_projectsList__dheFT","activeProject":"NavigationPanel_activeProject__RwmzP","navigationCard":"NavigationPanel_navigationCard__KvOLv"};